import './SocialProofs.scss';

import { SocialProofsBlock } from '@travelwin/cms/types';
import cn from 'classnames';

import { SocialProof } from './SocialProof';

type Props = {
  socialProofs: Pick<SocialProofsBlock, 'rows' | 'mobileVariant'>;
  className?: string;
};

const cssClassName = 'c-SocialProofs';

const getVariantClassName = (variant?: SocialProofsBlock['mobileVariant']) => ({
  [`${cssClassName}--horizontal`]: variant === 'horizontal',
  [`${cssClassName}--vertical-centered`]: variant === 'vertical-centered',
  [`${cssClassName}--vertical-list`]: variant === 'vertical-list',
});

export const SocialProofs = ({ socialProofs, className }: Props) => {
  const numberOfElements = socialProofs.rows?.length;

  return socialProofs.rows ? (
    <div
      className={cn(
        cssClassName,
        getVariantClassName(socialProofs.mobileVariant),
        `${cssClassName}--size-${numberOfElements}`,
        className,
      )}
    >
      {socialProofs.rows.map((socialProofRow) => (
        <SocialProof
          key={socialProofRow.id || socialProofRow.text}
          {...socialProofRow}
        />
      ))}
    </div>
  ) : null;
};
